// extracted by mini-css-extract-plugin
module.exports = {"planFeatureItemList":"styles_planFeatureItemList__KW6Nc","planFeatureItem":"styles_planFeatureItem__lbxP8","planFeatureItemText":"styles_planFeatureItemText__v9s6_"};